export default __webpack_public_path__ + "static/media/5e5a874960958825.e0b927f6a46d3a622ebae6430336a33f.svg";